import React from 'react'
import styled from 'styled-components'

import {
    BigformActionedAction,
    InvoiceGeneratorActionedField,
    invoiceGeneratorActioned,
} from '@/analytics/segment'
import Textarea from '@/components/textarea'
import type {InvoiceGeneratorFragment} from '@/graphql-types'
import {colors, tokens} from '@/theme'

import {StyledBackgroundWrapper} from './shared-styles'
import type {Dispatch, State, StateKey} from './state'
import {Actions} from './state'

interface Props {
    dispatch: Dispatch
    state: State
    content: InvoiceGeneratorFragment['data']
}

export const NotesAndTerms = ({dispatch, state, content}: Props) => {
    const handleInputChange = (key: StateKey, value: string) => {
        dispatch({
            type: Actions.SET_VALUES,
            key,
            value,
        })

        invoiceGeneratorActioned({
            action: BigformActionedAction.Interacted,
            field: InvoiceGeneratorActionedField.Notes,
        })
    }

    return (
        <Wrapper>
            <StyledTextarea
                label={content.notes_label}
                placeholder={`Description`}
                value={state.notes}
                onChange={(value) => handleInputChange('notes', value)}
            />
            <StyledTextarea
                label={content.terms_label}
                placeholder={`Description`}
                value={state.terms}
                onChange={(value) => handleInputChange('terms', value)}
            />
        </Wrapper>
    )
}

const Wrapper = styled(StyledBackgroundWrapper)`
    display: grid;

    > *:not(:first-child) {
        margin-top: ${tokens.spacing20};
    }
`

const StyledTextarea = styled(Textarea)`
    grid-template-rows: max-content 1fr;

    & textarea {
        background-color: ${colors.background.default};
    }
`
